import {
  SAVE_RENTALBOARD_URL,
  INITIALIZE_URL
} from "constants/ActionTypes";
import { INITIAL_STATE } from "constants/AppConstants";

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SAVE_RENTALBOARD_URL:
      return { ...state, rentalBoardUrl: payload };
    case INITIALIZE_URL:
      return { ...state, rentalBoardUrl: payload };
    default:
      return state;
  }
};
